export default __webpack_public_path__ + "static/media/back_1_3_m.1ed273b1.png";